import ActiveRecord from "@/models/ActiveRecord";
import Option from "@/models/Option";

export const Type = {
  image: Symbol("IMAGE"),  //standard image option
  plain: Symbol("PLAIN"),  //show options condensed, with no images
  welcome: Symbol("WELCOME"),  //welcome page
  end: Symbol("END"),  //end page
};

export default class Step extends ActiveRecord {
  // entity is a required property for all models.
  static entity = "step";

  //foreign key of the parent entity
  static foreignKey = "survey_id";

  static get type() {
    return Type;
  }

  // List of all fields (schema) of the post model. `this.attr()` declares
  // a generic field type with a default value as the first argument.
  static fields() {
    return {
      id: this.uid(() => this.uuidv4()),
      survey_id: this.attr(null),
      title: this.attr("A Heading"),
      subtitle: this.attr("A Subtitle"),
      type: this.attr(this.type.image), //question/option type: image, plain
      image: this.attr(null),
      image_link: this.attr(null),
      allow_many: this.boolean(false), //whether to allow user to select more than one answer choice
      size: this.attr('md'), //'sm', 'md', 'lg'
      order: this.number(null),
      options: this.hasMany(Option, "step_id"),
      required: this.boolean(false),

    };
    
  }

  //Sample Step data
  //fk_val = foreign key value (survey_id)
  static dummyData(fk_val) {
    let step_id = this.uuidv4();

    return {
      id: step_id,
      survey_id: fk_val,
      type: "image",
      title: "A brand new step",
      subtitle: "A new description",
      order: 99999, //dummy value to ensure it is inserted at end of list; real order value will be determined in afterCreate hook
      options: Option.seed(step_id, 2, true),
    };
  }

  get imageHeightClass() {
    if (this.size === "sm") return "h-20 sm:h-20 md:h-20";
    if (this.size === "md") return "h-20 sm:h-24 md:h-28";
    if (this.size === "lg") return "h-20 sm:h-32 md:h-40";
    else return "h-20 sm:h-24 md:h-28";
  }

  //The name of the class for the given panel size
  get panelWidthClass(){
    if (this.size === "sm") return "panel-sm";
    if (this.size === "lg") return "panel-lg";  
    else return "panel-md"; 
  }

  //num_items = number of answer choices, e.g. options.length
containerWidth(num_items=null) {

    num_items = num_items || this.options.length;
    console.log ('num_items: ' + num_items + 'len: ' + this.options.length)
    if (num_items > 3) {
      var max_rows = Math.ceil(num_items / 2);
      var padding = 32; // Padding size of option-object wrapper "px-4"=32px 

      //panel size at the largest media breakpoint
      var max_panel_size = this.maxPanelWidth();
      console.log('max panel:' + max_panel_size);
      var pixels = max_rows * (max_panel_size + padding);
      return pixels + "px";
    } else return "100%";
    //return '1022px';
  }

  /* Returns the width the option panel at the largest media breakpoint */
  /* IMPORTANT: This needs to be consistent with the CSS in the Widget/Builder/Preview */
  maxPanelWidth(){
    if (this.size === "sm") return 250;
    if (this.size === "lg") return 400;  
    else return 330; 
  }

 
  static afterCreate(model){

    this.reorder(model);

  }

  static afterDelete(model){

    this.reorder(model);

  }


  //Clone an individual step, replacing ids and related option foreign keys and ids
  static clone(orig) {
    let step = { ...orig }; //Make a fresh copy of step object including child options
    step.id = this.uuidv4(); //Create new primary id
    step.title = orig.title + ' (copy)';

    step.options.forEach( (option) => {

      option.id = this.uuidv4();
      option.step_id = step.id;
    });

    //Replace foreign keys for each child option with new step id
    //step.options = this.updateForeignKeys(step.options, "step_id", step.id);

    //Create new primary ids for each option
    //step.options = this.generatePrimaryKeys(step.options, "id", step.id);

    return step;
  }
}
